import { useEffect } from 'react';
import {
  JobDetailResponse,
  ScoutJobDetailResponse,
} from '@doda/api-client/aspida/@types';
import { useAppSelector } from '@doda/pc/src/redux/hooks';
import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { tabSelector } from '@doda/pc/src/redux/selectors/queryParams';
import { TAB_PHOTOS } from '@doda/common/src/constants/properties/const';
import { adobeAnalyticsScriptsSelector } from '@doda/common/src/redux/features/analytics';
import {
  measureAbTestForManuscriptE,
  measureApplyButtonChangeImpression,
  measureImpression,
  measureImpressionPublicationPhotoGtm,
} from '../../logics/analytics';
import { Tab } from '../../types/tab';

/**
 * 求人詳細 PV 計測
 * @param job 求人詳細情報
 * @param isScout スカウト求人かどうか
 * @param initialTab 初期選択タブ
 * @param isCasualInterview カジュアル面談か
 */
export const useImpressionAnalytics = (
  job: JobDetailResponse | ScoutJobDetailResponse,
  isScout: boolean,
  initialTab: Tab,
  isCasualInterview?: boolean
) => {
  const query = useAppSelector(appQueryParamsSelector);
  const tab = useAppSelector(tabSelector);
  useEffect(() => {
    if (!job) return;
    if (tab === TAB_PHOTOS) {
      // 写真タブが選択されている場合の計測処理
      measureImpressionPublicationPhotoGtm(
        job,
        query,
        isScout,
        isCasualInterview
      );
    } else {
      measureImpression(
        job,
        query,
        isScout,
        tab ?? initialTab,
        isCasualInterview
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);
};

/**
 * E原稿動画化用PV計測
 * @param abTestForManuscriptEGroupNo - E原稿動画ABテストグループNo
 * @param manuscriptType - 原稿種別
 */
export const useMeasureAbTestForManuscriptE = (
  abTestForManuscriptEGroupNo: number,
  manuscriptType: string | undefined
) => {
  const isAdobeScript = useAppSelector(adobeAnalyticsScriptsSelector);
  useEffect(() => {
    if (!isAdobeScript || manuscriptType !== 'E') return;
    // PV計測より前に発火しないように発火を遅らせる
    setTimeout(() => {
      measureAbTestForManuscriptE(abTestForManuscriptEGroupNo);
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdobeScript]);
};

/**
 * DODASITE-25064 応募ボタンUI変更ABテスト imp計測
 * @param applyButtonChangeAbtestGroupNo 応募ボタンUI変更ABテストグループNo
 */
export const useMeasureApplyButtonChangeImpression = (
  applyButtonChangeAbtestGroupNo: string
) => {
  const isAdobeScript = useAppSelector(adobeAnalyticsScriptsSelector);
  useEffect(() => {
    if (
      isAdobeScript &&
      applyButtonChangeAbtestGroupNo !== '0' &&
      !!applyButtonChangeAbtestGroupNo
    ) {
      // PV計測より前に発火しないように発火を遅らせる
      setTimeout(() => {
        measureApplyButtonChangeImpression(applyButtonChangeAbtestGroupNo);
      }, 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdobeScript]);
};
